module.exports = __webpack_public_path__ + "img/20210906-1630898474121074.60257d0a.jpg";